// extracted by mini-css-extract-plugin
export default {"restForm":"VisualizacionAsignacionNivel_restForm__4MF20","submit":"VisualizacionAsignacionNivel_submit__YTtfM","textCenter":"VisualizacionAsignacionNivel_textCenter__EXyDN"};